import React from 'react';

import i18n from 'i18n-js';
import { Typography, IconButton } from '@material-ui/core';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';

import styles from './styles';
import { AdvancedPriceOption } from './components/AdvancedPriceOption';
import { PriceOptionForm } from './components/PriceOptionForm';
import { useAppSelector } from 'index';
import { actionCreators } from 'store/restaurantDetailsStore/actionCreators';
import { useDispatch } from 'react-redux';

export default function AdvancedPricing() {
    const classes = styles();
    const dispatch = useDispatch();
    const restaurant = useAppSelector((state) => state.restaurantDetails.restaurantInformation);
    const [addNew, setAddNew] = React.useState(false);

    function createNewPriceOption(name: string) {
        setAddNew(false);
        dispatch(actionCreators.createPricingLevel(restaurant.id, name));
    }

    return (
        <div className={classes.root}>
            <Typography variant="h5" align="left">
                {i18n.t('restaurant.advancedPricing')}
            </Typography>
            <div className={classes.pricesContainer}>
                <Typography variant="h6" align="left">
                    {i18n.t('restaurant.pricingLevels')}
                </Typography>
                <AdvancedPriceOption name={i18n.t('common.standard')} disabled />
                {restaurant.pricingLevels.map((level) => (
                    <AdvancedPriceOption name={level.name} id={level.id} />
                ))}
                {addNew ? (
                    <PriceOptionForm
                        action={createNewPriceOption}
                        cancel={() => setAddNew(false)}
                    />
                ) : (
                    <IconButton onClick={() => setAddNew(true)}>
                        <AddCircleOutlineIcon
                            color="primary"
                            fontSize="large"
                            style={{ cursor: 'pointer', marginTop: 15 }}
                        />
                    </IconButton>
                )}
            </div>
        </div>
    );
}
